import React, { useContext } from 'react'
import * as S from './Styled';
import Default from '../Modal/Default/Default';
import { SlugContext } from '../../context/SlugContext';

const Login = ({ 
  showButton = true,
  hotArea = null,
  name,
  color,
  width,
  height,
  border,
  hotAreaName,
  longDescription,
  logo,
  hoverColor,
  incentiveId,
  slug
 }) => {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      {showButton && (
        <S.AcessarButton 
          variant="outlined" 
          onClick={handleClickOpen}
          sx={{ 
            color,
            width,
            height,
            '&:hover': {
              borderColor: `#${hoverColor}` || 'white',
              border: border
            },
            border: border,
          }}
        >
          {name}
        </S.AcessarButton>
      )}
      <Default 
      slug={slug}
      name={hotAreaName} 
      longDescription={longDescription}
      open={open}
      handleClose={handleClose}
      logo={logo}
      incentiveId={incentiveId}
      ></Default>
    </React.Fragment>
  )
}

export default Login